module.exports = __webpack_public_path__ + "static/Infographic4_1_Taipei-27f5a63c01debe41fd7eaecb69f3c066.png";